import "./Checkbox.scss";

interface Props {
  text: string;
  value: number | string;
  checked?: boolean;
  onChange?: any;
}

export const Checkbox = ({ text, value, checked, onChange }: Props) => {
  const onChangeCheckbox = (e: any) => {
    if (onChange) {
        const isChecked = e?.target.value === 'on'
        onChange(value, isChecked);
    }
  };

  return (
    <label className="checkbox">
      <span className="text">{text}</span>
      <input type="checkbox" checked={checked} onChange={onChangeCheckbox} />
      <span className="checkmark"></span>
    </label>
  );
};
